export default __webpack_public_path__ + "static/media/pin-code.539824a9.png";